<template>
    <!-- component -->

  <div data-popover="profile-info-popover"
    class="m-auto max-w-[24rem] whitespace-normal break-words rounded-lg border border-blue-gray-50 bg-white p-4 font-sans text-sm font-normal text-blue-gray-500 shadow-lg shadow-blue-gray-500/10 focus:outline-none">
    <div class="flex items-center justify-between gap-4 mb-2">
      <img alt="Stawski Maxime" class="relative inline-block object-cover object-center w-12 h-12 rounded-full" :src="linkPhoto"/>
        <a href="https://www.linkedin.com/in/maxime-stawski" target="_blank">
        <button
        class="select-none rounded-lg bg-gray-900 py-2 px-3 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        type="button" data-ripple-light="true">
        LinkedIn
        </button>
        </a>
    </div>
    <h6
      class="flex items-center gap-2 mb-2 font-sans text-base antialiased font-medium leading-relaxed tracking-normal text-blue-gray-900">
      <span>Stawski Maxime</span>
      <a class="text-sm text-blue-gray-700" href="#">

      </a>
    </h6>
    <p class="block font-sans text-sm antialiased font-normal leading-normal text-gray-700">
        {{ textPresentation }}
    </p>
    <div class="flex items-center gap-8 pt-4 mt-6 border-t border-blue-gray-50">
      <p class="flex items-center gap-1 font-sans text-xs antialiased font-normal text-gray-700">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
          aria-hidden="true" class="-mt-0.5 h-3.5 w-3.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"></path>
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"></path>
        </svg>
        Lille - France
      </p>
      <a class="flex items-center gap-1 font-sans text-xs antialiased font-normal text-gray-700">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
          aria-hidden="true" class="-mt-0.5 h-3.5 w-3.5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z">
          </path>
        </svg>
        Developpement FullStack / Front / Back
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ComponentPresentation',
  props: {
    textPresentation: String,
    linkPhoto: String,
    }
}
</script>
